module.exports = __webpack_public_path__ + "img/99.027e3cc3.png";